import { MainContentArea, ContentHeader } from "melco-ui";
import { useState } from "react";
import { PaymentsList } from "../../components/reports/payments/PaymentsList";
import { useTranslation } from "react-i18next";

// To Do: Add BreadCrum
// Add Translation
export const Payments: React.FC = () => {
  //const breadcrumb = useBreadcrumb("orders");
  const [openProcessPaymentDrawer, setOpenProcessPaymentDrawer] =
    useState<boolean>(false);

  const setOpenProcessPaymentDrawerFunction = (v: boolean) => {
    setOpenProcessPaymentDrawer(v);
  };

  const { t } = useTranslation();

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.payments")}
        // extra={
        //   roles.VIRTUAL_SECURITY_GENERATE && (
        //     <GenratePaymentButton
        //       setOpenGenratePaymentDrawerFunction={
        //         setOpenGenratePaymentDrawerFunction
        //       }
        //     />
        //   )
        // }
        />
      }
    >
      <PaymentsList
        openProcessPaymentDrawer={openProcessPaymentDrawer}
        setOpenProcessPaymentDrawerFunction={
          setOpenProcessPaymentDrawerFunction
        }
      />
    </MainContentArea>
  );
};
